export default __webpack_public_path__ + "static/media/poster19.c2c12545.png";